import AppDevice from "./device"


export async function getContactList(){
    try{
        let url = `${AppDevice.ServerUrl}/listaclientes`
        const req = await fetch(url)
        const res = await req.json()
        const contactos = res.map((item)=>{
            return {
                phone:item.phone,
                nombre:item.name,
                area:item.area
            }
        })
        return (contactos)
    }
    catch(e){
        throw e
    }
}
